// src/hooks/useTimezoneSync.ts
import { useEffect } from 'react';
import { useAuthStore } from '@/stores/authStore';
import { detectBrowserTimezone } from '../utils/utils';
import { useUpdateUserData } from '@/features/auth/services/useAuthQueries';

export const useTimezoneSync = () => {
    const { user } = useAuthStore();
    const { mutateAsync: updateUserProfile } = useUpdateUserData();

    useEffect(() => {
        // 브라우저 시간대 감지
        const browserTimezone = detectBrowserTimezone();
        // console.log('브라우저 시간대:', browserTimezone);

        // 로그인한 사용자이고 시간대가 다르면 업데이트
        if (user && user.timezone !== browserTimezone) {
            // console.log(
            //     `시간대 변경 감지: ${user.timezone} → ${browserTimezone}`
            // );

            // 사용자 프로필 업데이트
            updateUserProfile({
                userId: user.id,
                userData: { timezone: browserTimezone },
            })
                .then(() => {
                    // 변경된 시간대에 맞는 데이터 다시 로드하기 위해 새로고침
                    window.location.reload();
                })
                .catch(e => {
                    console.error('시간대 변경 감지 실패:', e);
                });
        }

        // 시간대 변경 감지를 위한 이벤트 설정
        const checkTimezone = () => {
            const currentTimezone = detectBrowserTimezone();
            if (user && user.timezone !== currentTimezone) {
                updateUserProfile({
                    userId: user.id,
                    userData: { timezone: currentTimezone },
                })
                    .then(() => {
                        // 변경된 시간대에 맞는 데이터 다시 로드하기 위해 새로고침
                        window.location.reload();
                    })
                    .catch(e => {
                        console.error('시간대 변경 감지 실패:', e);
                    });
            }
        };

        // 활성화 상태로 돌아올 때 시간대 확인 (사용자가 시스템 설정 변경 후 앱으로 돌아올 경우 대비)
        window.addEventListener('focus', checkTimezone);

        return () => {
            window.removeEventListener('focus', checkTimezone);
        };
    }, [user, updateUserProfile]); // user 객체가 변경될 때만 실행
};
